import React, {useState} from 'react';
import {Button, Modal, Row, Spin, notification} from "antd";
import '../modals.css';
import i18n from '../../../i18n';
import {legalEntityService} from "../../../services/legal-entity.service";

export default function ModalAddConsignorGosLogWithApproveDocs({
  isShow,
  setIsShow,
  text,
  consignorId,
  legalEntityId,
  onSubmitSuccess,
}) {
  const [loading, setLoading] = useState(false);

  let bigButtonStyle = {
    width: '190px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    borderColor: "#1CAA53"
  };

  const textStyle = {
    textAlign: 'center',
    color: 'black'
  };

  const handleSubmit = () => {
    if (!consignorId || !legalEntityId) {
      notification.error({
        message: i18n.t('components.notification.titles.error'),
        description: 'Не определены consignorId или legalEntityId',
      });
      return;
    }

    setLoading(true);
    legalEntityService.addConsignorGosLogWithApproveDocs(consignorId, legalEntityId)
      .then((response) => {
        if (typeof onSubmitSuccess === 'function') {
          onSubmitSuccess(response && response.message ? response.message : '');
        } else {
          notification.success({
            message: i18n.t('components.notification.titles.success'),
            description: response && response.message ? response.message : '',
          });
        }
        setIsShow(false);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.error'),
          description: err,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('Статус регистрации в ГосЛог')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      style={{maxWidth: '450px'}}
      align={null}
      visible={isShow}
      onCancel={() => setIsShow(false)}
      footer={[
        <Button
          htmlType="submit"
          style={bigButtonStyle}
          key="submit"
          type="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          Отправить
        </Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row className="add-padding-10 -centered">
          <h2 style={textStyle}>{text}</h2>
        </Row>
      </Spin>
    </Modal>
  );
}
